export class DataListModel {
  items: any[] = [];
  totalElements?: number = 0;
  totalPages?: number = 0;
}
